import React, { useState, useEffect } from 'react'
import { Modal, Button, Image } from 'react-bootstrap'
import { getWorkspaceAccessById } from 'actions';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { getFormatedDateTime } from 'utils/general';
import { createUseStyles } from 'react-jss';
import AccessRights from 'utils/AccessRights';

const useStyles = createUseStyles({
  visibleModal: {
    '& .modal-content': {
      width: '477px',
      height: '480px',
      margin: '0 auto',
    },
  },
  modalCloseBtn: {
    position: 'absolute',
    top: '15px',
    right: '13px',
  },
});

const VisibleModalContent = ({ onHide, ...props }) => {

  const classes = useStyles();
  const dispatch = useDispatch();

  const session = useSelector(state => state.session);
  const workspaceAccessState = useSelector(state => state.workspaceAccessState);
  const themeState = useSelector(state => state.themeState);

  const [workSpaceData, setWorkSpaceData] = useState([]);

  useEffect(() => {
    if (workspaceAccessState.workspaceAccessRecord) {
      setWorkSpaceData(workspaceAccessState.workspaceAccessRecord);
    }
  }, [workspaceAccessState.workspaceAccessRecord]);

  const showUpdateForm = (recordId) => {
    dispatch(getWorkspaceAccessById(recordId, 'update'));
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className={classes.visibleModal}
      >
        <Modal.Header className='d-block'>
          <Modal.Title id="contained-modal-title-vcenter" className='text-center page-heading'>
            Workspace
            <p className='text-secondary font-12 font-weight-normal'>AI</p>
          </Modal.Title>
          <Button onClick={onHide} variant='none' className={`border-0 ${classes.modalCloseBtn}`} > <Image src={themeState.themeMode === 'dark' ? '/assets/images/close-circle-dark.svg' : '/assets/images/close-circle.svg'} /></Button>
        </Modal.Header>
        <Modal.Body className='border-bottom-0'>
          <div className='d-flex justify-content-between mb-3'>
            <p className='font-13 font-weight-medium page-heading'>Workspace Name</p>
            <p className='font-13 font-weight-normal text-secondary'> {
              !isEmpty(workSpaceData.name) ?
                workSpaceData.name : ''
            }</p>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <p className='font-13 font-weight-medium page-heading'>Created By</p>
            <p className='font-13 font-weight-normal text-secondary'>
              {
                !isEmpty(workSpaceData.created_by_user) ?
                  workSpaceData.created_by_user.name : ''
              }
            </p>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <p className='font-13 font-weight-medium page-heading'>Created At</p>
            <p className='font-13 font-weight-normal text-secondary'>{getFormatedDateTime(workSpaceData.date_created)}</p>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <p className='font-13 font-weight-medium page-heading'>Last Updated By</p>
            <p className='font-13 font-weight-normal text-secondary'>
              {
                !isEmpty(workSpaceData.updated_by_user) ?
                  workSpaceData.updated_by_user.name : ''
              }
            </p>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <p className='font-13 font-weight-medium page-heading'>Last Updated At</p>
            <p className='font-13 font-weight-normal text-secondary'>{getFormatedDateTime(workSpaceData.date_last_modified)}</p>
          </div>
        </Modal.Body>
        <Modal.Footer className='border-top-0 justify-content-center'>

          {(AccessRights(session.current_page_permissions, 'edit', workSpaceData.created_by) && workSpaceData.is_deleted === 'n') ?
            <Button variant='none' className='gradient-btn ' onClick={() => showUpdateForm(workSpaceData.id)}><Image src='/assets/images/edit-white.svg' className='me-2 text-white' />Update</Button>
            : ''
          }
          {' '}



          <Button variant='none' className='gradient-border page-heading' onClick={onHide}>Cancel</Button>

        </Modal.Footer>
      </Modal>
    </>
  )
}

export default VisibleModalContent
